document.addEventListener('DOMContentLoaded', () => {

    const sliderSwiper = new Swiper('.slider-swiper', {
		loop: true,
		spaceBetween: 15,
		speed: 800,
		navigation: {
			nextEl: ".slider-next",
			prevEl: ".slider-prev",
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0
			},
			600: {
				slidesPerView: "auto"
			}
		},
	});

	const reviewsSwiper = new Swiper('.reviews-swiper', {
		loop: true,
		slidesPerView: 1,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: ".reviews-next",
		},
		pagination: {
			el: ".reviews-pagination",
			clickable: true,
		}
	});
	const gallerySwiper = new Swiper('.gallery-swiper', {
		loop: true,
		speed: 800,
		navigation: {
		  nextEl: ".gallery-next",
		  prevEl: ".gallery-prev",
		},
		pagination: {
		  el: ".gallery-pagination",
		  clickable: true,
		},
		breakpoints: {
		  320: {
			slidesPerView: 1
		  },
		  600: {
			slidesPerView: 3,
			centeredSlides: true,
			spaceBetween: 20
		  }
		}
	});
});